import { Component, Input, OnDestroy } from '@angular/core';
import { Command, ConfigChoice } from '@mri/types';
import { ConfigResourceService, GenericResourceService } from '@mri/app/resources';
import { mergeMap, Subject, Subscription, tap } from 'rxjs';
import { ChoiceTypes } from '@mri/enums';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatMenuModule } from '@angular/material/menu';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BadgeComponent } from '../../demo/pages/components/data-display/badge/badge.component';

@Component({
  selector: 'app-command-resume-view',
  standalone: true,
  imports: [
    CardComponent,
    MatMenuModule,
    NgApexchartsModule,
    MatProgressBarModule,
    BadgeComponent
  ],
  templateUrl: './command-resume-view.component.html',
  styleUrl: './command-resume-view.component.scss'
})
export class CommandResumeViewComponent implements OnDestroy {
  private _subscription = new Subscription();
  private _command$ = new Subject<Command>();
  private _commandId$ = new Subject<string>();
  private _commandKey$ = new Subject<string>();

  element?: Command;
  complementKey?: ConfigChoice ;
  showResponseText?: boolean = false;

  @Input() set command(value: Command) {
    this._command$.next(value);
  }

  @Input() set commandId(value: string) {
    this._commandId$.next(value);
  }

  @Input() mode = 'normal';

  constructor(
    private _genericSrv: GenericResourceService,
    private _configSrv: ConfigResourceService
  ) {

    this._subscription.add(
      this._commandId$.pipe(
        mergeMap(commandId => this._genericSrv.getElement<Command>('commands', commandId)),
        tap(response => this._command$.next(response.object))
      ).subscribe()
    );

    this._subscription.add(
      this._command$.pipe(
        tap(command => {
          this.showResponseText = false;

          if(!command) return this.element = undefined;

          const prev = {};
          if(this.element?._id === command._id) Object.assign(prev, this.element || {});

          this.element = {...prev, ...command};

          this._commandKey$.next(command.commandKey);
        }),
      ).subscribe()
    );

    this._subscription.add(
      this._commandKey$.pipe(
        tap( commandKey => {
          this.complementKey = this._configSrv
            .getChoices(ChoiceTypes.COMMAND)
            .find( c => c.value === commandKey);
        })
      ).subscribe()
    )
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

}
